import PnrIcon from "@mui/icons-material/ConfirmationNumber";
import BaseTag from "./BaseTag";

const PnrTag = (props) => <BaseTag icon={<PnrIcon />} label={props.value} />;

export default PnrTag;
